<template>
  <div class="container">

    <div class="main">
      <div>&nbsp;</div>
      <div class="logo-wrap">
        <div class="logo">
          <img src="static/report/logo_zyw.png">
        </div>
        <p class="tip">门诊版</p>
        <div style="clear: both;"></div>
      </div>
      <div class="sep"></div>
      <div class="title">
        <p>移宇在线报表系统</p>
      </div>
      <div class="box">
        <div class="wrap">
          <div style="height: 1px;"></div>
          <div class="row">
            <div class="img-wrap"><img src="/static/report/icon_user.png"></div>
            <input type="text" v-model="username" placeholder="账号"/>
          </div>
          <div class="row">
            <div class="img-wrap"><img src="/static/report/icon_password.png"></div>
            <input type="password" v-model="password" placeholder="密码" />
          </div>
          <div class="remember_pwd_row">

            <div class="fl c1">
              <input id="remember_pwd_check" type="checkbox" />
            </div>
            <div class="fl c2">
              <span>记住密码</span>
            </div>
            <div style="clear: both"></div>
          </div>
          <div class="alert" :class="flag?'dis':''">
            <img src="../../static/legend/Alert.png" alt="">
            <span>检测到您已离开该医院所在城市，为了医院数据安全，请确保您的设备处于所登录医院的所在地。</span>  
          </div>
          <el-button @click="onBtnLogin" class="login-btn">登录 </el-button>
        </div>
      </div>

      <div class="out_link">
        <p><a href="https://cgms.medtrum.cn">切换到医院版</a></p>
      </div>
    </div>

    <div class="footer">
     <span>
          <a :href="contactURL"> 联系我们 </a>
          <a :href="privacyURL">|  隐私政策 </a>
          <a :href="termsOfUseURL">|  服务协议 | </a>

          ©2021 上海移宇科技有限公司 版权所有<br/>
          <a target=_blank href="http://beian.miit.gov.cn/"> 沪ICP备08013753号-3  </a>
          <img src="/static/beian.png" />
          <a target=_blank href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"> 沪公网安备 31011502014155号 </a>
     </span>
    </div><!--footer 结束-->

  </div> <!--container结束-->
</template>

<script>
  // import echarts from 'echarts'
  import auth from '../auth/auth'
  export default {
    data() {
      return {
        contactURL:'',
        privacyURL:'',
        termsOfUseURL:'',
        username: '',
        password:'',
        flag:true,

      }
    },
    computed:{
      // getLanguage(){
      //
      // }
    },
    watch:{
      // getLanguage(val){
      //
      // }
    },
    mounted(){
      let req=this.getRequest()
      this.cureNo = req.cureNo;
      if(sessionStorage.getItem('1061Flag')=='true'){
        this.flag =false
        sessionStorage.setItem('1061Flag',false)
      }
      setTimeout(()=>{
        let host='https://www.medtrum.com.cn'
        this.contactURL = host+'/contact.html';
        this.privacyURL = host+'/privacy_policy.html';
        this.termsOfUseURL = host + '/terms_of_use.html';
      }, 50)

    },
    methods: {

      onBtnLogin() {
        if (!this.username || !this.password) {
          this.$message.error("请输入账号密码");
          return;
        }
        this.flag=true
        sessionStorage.setItem('1061Flag','false')
        this.$http.post('/api/v2.1/login', {
          'user_name':this.username,
          'password':this.password,
          'user_type':'M',
          'flag':'clinic_report_login'
        }).then(function (res) {
          let error=res.data.error;
          if (0==error) {
            let username = res.data.username;
            let org_name =res.data.org_name;
            sessionStorage.setItem('created_by',res.data.created_by)
            sessionStorage.setItem('username', username);
            sessionStorage.setItem('org_name',org_name)
            sessionStorage.setItem('app_type',res.data.app_type)
            this.$router.push('/reportList')
          }else if(error === 9){
            const tip = `密码输入错误，还剩${res.body.left_try_num}次尝试，请确认登录密码正确`;
            this.$message.error(tip);
          } else if (error === 62){
            const tip = `密码错误次数超过限制，账户已被锁定，请${res.body.unlock_time_left}分钟后再试`;
            this.$message.error(tip)
          }else if(error ===1061){
            this.flag=false
            sessionStorage.setItem('1061Flag','true')
          }
          else {
            this.$message.error("登录失败");
          }
        }, function (err) {
          this.$message.error("请稍后重试");
        })
      },
      getRequest() {
        let href = location.href;
        let theRequest={};
        if (href.indexOf("?") != -1) {
          let search =  href.substring(href.indexOf("?")+1)
          let strs = search.split("&");
          for (let i = 0; i < strs.length; i++) {
            let pair = strs[i].split("=");
            theRequest[pair[0]] = unescape(pair[1]);
          }

        }
        return theRequest;
      },

    },
  }
</script>

<style scoped>
  .displayPass {
    text-security: disc;
    -webkit-text-security: disc;
  }

  p,body,html {
    margin:0;
  }

  .container {
    min-height: 800px;
    min-width: 800px;
    height: 100%;
    width: 100%;
    background-color:#0c544f;
    background-image: url("/static/report/home_bj.png");
    background-size: 100% 100%;
    /*background-size: cover;*/
    /*background-color: #000000;*/
  }

  .container .main {
    width: 440px;
    margin:0 auto;
  }

  .container .main .logo-wrap {
    margin-top:100px;
  }

  .container .main .logo-wrap .tip {
    color: #fff;
    font-size: 36px;
    margin-top:20px;
    float:right;
  }

  .container .main .logo {
    float:left;
  }

  .container .main .sep {
    border-bottom: 1px solid #fff;
    margin-top:24px;
    margin-left:70px;
  }

  .container .main .title {
    margin-top:20px;
    margin-left:70px;
    font-size:30px;
    color:#fff;
    letter-spacing:10px;
    font-family:Source Han Sans CN;
    /*color:#ffffff;*/
    /*font-size:36px;*/
    /*letter-spacing:200px;*/
    /*padding-bottom:11px;*/

  }

  .out_link {
    /*margin:0 auto;*/
    margin-top:30px;
  }

  .out_link p {
    text-align: center;
    color:#fff;
    font-size: 20px;
    cursor: pointer;
  }

  .out_link p a {
    color: #fff;
    text-decoration: none;
  }

  .container .main .box {
    width:440px;
    height:306px;
    background-color:#fff;
    border-radius:8px;
    box-shadow:0px 0px 15px rgba(0, 0, 0, 0.47);
    margin-top:40px;
  }

  .container .main .box .wrap {
    width:90%;
    margin: 0 auto;
  }

  .container .main .box .wrap .row {
    margin-top:15px;
    border-bottom: 1px solid #0c544f;
  }

  .container .main .box .wrap .row input {
    /*width: 100%;*/
    width: 350px;
    height:40px;
    outline: none;
    border: none;
    font-size:20px;
    padding-left:10px;
  }

  .remember_pwd_row {
    /*display: table-cell;*/
    /*vertical-align: middle;*/
    margin-top:10px;
  }

  .remember_pwd_row  .fl {
    float:left;
  }

  .remember_pwd_row  .c1 {
    /*height: 100%;*/
    /*display: table-cell;*/
    height: 30px;
    padding-top: 3px;
    vertical-align: middle;
  }

  .remember_pwd_row  .c2 {
    margin-left: 5px;
  }
  .remember_pwd_row input {
    /*margin-top: 5px;*/
  }

  .remember_pwd_row span {
    line-height: 30px;
    color:#999;
  }

  .login-btn {
    width: 376px;
    height: 56px;
    background-color: #0c544f;
    border-radius: 30px;
    margin: 0 auto;
    cursor: pointer;
    margin-top: 10px;
    font-family: Source Han Sans CN;
    color: #ffffff;
    font-size: 26px;
    line-height: 56px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .login-btn p {
    font-family:Source Han Sans CN;
    color:#ffffff;
    font-size:26px;
    line-height: 56px;
    padding-bottom:11px;
    text-align:center;
  }

  #remember_pwd_check {
    height:24px;
    width: 24px;
    color: #fff;
    position: relative;
  }

  #remember_pwd_check:after {
    position: absolute;
    width: 21px;
    height: 21px;
    top: 1px;
    left: 1px;
    content: " ";
    background-color: #fff;
    color: #000;
    display: inline-block;
    visibility: visible;
    /*padding: 0px 3px;*/
    /*border-radius: 3px;*/
    /*padding-left:2px;*/
    text-align: center;
    line-height: 24px;
  }

  #remember_pwd_check:checked:after {
    content: "✓";
    font-size: 18px;
    font-weight: bold;
  }

  .container .main .box .wrap .img-wrap {
    display: inline-block;
    vertical-align: middle;
    /*margin-top: 5px;*/
    /*padding-top: 5px;*/
  }

  /*.container .main .box .wrap .img-wrap img {*/
  /*  vertical-align: center;*/
  /*}*/

  .container .main .box .wrap img {
    /*margin-top:15px;*/
    /*padding-top: 5px;*/
    /*line-height: 40px;*/
    /*display: inline-block;*/
  }

  .alert{
    margin-top: 10px;
  }
  .alert span{
    color: coral;
  }
  .dis{
    visibility: hidden;
  }
  .footer{
    height:21px;
    width:80%;
    margin:7% auto 0;
    font-size:18px;
    color:rgba(246,248,251,0.90);
    letter-spacing:-0.54px;
    text-align:center;
    font-family: SFUIText-Regular;
  }
  .footer a{
    color:rgba(246,248,251,0.90);
    text-decoration: none;
  }
  .footer a:hover{
    color:#0090D3;
  }
  @media screen and (max-width: 1500px){
    .footer{
      margin:6.5% auto 0;
    }
  }




  @media print {

  }
</style>



// WEBPACK FOOTER //
// LoginReport.vue?33a17d7c